import React, { useEffect, useState } from "react";
import api from "../../services/api";

const minutes = value => {
  const total = Number(value || 0);

  if (total < 60) return `${total.toFixed(0)} min`;

  const hours = Math.floor(total / 60);
  const mins = Math.round(total % 60);

  if (hours < 24) return `${hours}h ${mins}min`;

  const days = Math.floor(hours / 24);
  const restHours = hours % 24;

  return `${days}d ${restHours}h`;
};

const formatDateTime = value => {
  if (!value) return "-";

  try {
    return new Date(value).toLocaleString("pt-BR");
  } catch {
    return value;
  }
};

const scoreColor = score => {
  if (score >= 80) return "#dc2626";
  if (score >= 60) return "#f59e0b";
  if (score >= 30) return "#2563eb";
  return "#16a34a";
};

const scoreLabel = score => {
  if (score >= 80) return "Crítico";
  if (score >= 60) return "Alta prioridade";
  if (score >= 30) return "Média prioridade";
  return "Baixa prioridade";
};

const cardStyle = {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 16,
  padding: 16,
  boxShadow: "0 10px 30px rgba(15, 23, 42, 0.06)"
};

const LeadScoreDashboard = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    summary: {},
    leads: [],
    sellerRanking: []
  });

  const summary = data.summary || {};
  const leads = data.leads || [];
  const sellerRanking = data.sellerRanking || [];

  const loadData = async () => {
    try {
      setLoading(true);

      const response = await api.get("/dashboard/lead-score");

      setData(response.data || {});
    } catch (err) {
      console.error("Erro ao carregar Score de Leads:", err);
    } finally {
      setLoading(false);
    }
  };

  const openTicket = uuid => {
    if (!uuid) {
      alert("Este lead não possui UUID de atendimento.");
      return;
    }

    window.location.href = `/tickets/${uuid}`;
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div style={{ marginTop: 24, marginBottom: 32, gridColumn: "1 / -1", width: "100%" }}>
      <div
        style={{
          background: "linear-gradient(135deg, #020617 0%, #7f1d1d 55%, #dc2626 100%)",
          borderRadius: 24,
          padding: 24,
          color: "#fff",
          boxShadow: "0 20px 45px rgba(220, 38, 38, 0.22)",
          marginBottom: 18
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", gap: 16, flexWrap: "wrap" }}>
          <div>
            <div style={{ fontSize: 13, opacity: 0.85, fontWeight: 700 }}>
              Priorização Comercial
            </div>

            <h2 style={{ margin: "6px 0 4px", fontSize: 28, fontWeight: 900 }}>
              Score de Leads
            </h2>

            <div style={{ opacity: 0.9 }}>
              Priorize automaticamente os leads mais críticos para aumentar conversão.
            </div>
          </div>

          <button
            onClick={loadData}
            disabled={loading}
            style={{
              border: 0,
              borderRadius: 12,
              padding: "11px 18px",
              fontWeight: 800,
              cursor: "pointer",
              background: "#fff",
              color: "#b91c1c",
              alignSelf: "end"
            }}
          >
            {loading ? "Atualizando..." : "Atualizar score"}
          </button>
        </div>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 14, marginBottom: 16 }}>
        <div style={cardStyle}>
          <div style={{ color: "#64748b", fontSize: 12, fontWeight: 700 }}>Total analisado</div>
          <div style={{ color: "#0f172a", fontSize: 24, fontWeight: 900 }}>{summary.totalLeads || 0}</div>
        </div>

        <div style={cardStyle}>
          <div style={{ color: "#64748b", fontSize: 12, fontWeight: 700 }}>Críticos</div>
          <div style={{ color: "#dc2626", fontSize: 24, fontWeight: 900 }}>{summary.criticalLeads || 0}</div>
        </div>

        <div style={cardStyle}>
          <div style={{ color: "#64748b", fontSize: 12, fontWeight: 700 }}>Alta prioridade</div>
          <div style={{ color: "#f59e0b", fontSize: 24, fontWeight: 900 }}>{summary.highPriorityLeads || 0}</div>
        </div>

        <div style={cardStyle}>
          <div style={{ color: "#64748b", fontSize: 12, fontWeight: 700 }}>Média prioridade</div>
          <div style={{ color: "#2563eb", fontSize: 24, fontWeight: 900 }}>{summary.mediumPriorityLeads || 0}</div>
        </div>

        <div style={cardStyle}>
          <div style={{ color: "#64748b", fontSize: 12, fontWeight: 700 }}>Sem follow-up</div>
          <div style={{ color: "#ef4444", fontSize: 24, fontWeight: 900 }}>{summary.leadsWithoutFollowUp || 0}</div>
        </div>

        <div style={cardStyle}>
          <div style={{ color: "#64748b", fontSize: 12, fontWeight: 700 }}>Sem vendedor</div>
          <div style={{ color: "#7c3aed", fontSize: 24, fontWeight: 900 }}>{summary.leadsWithoutSeller || 0}</div>
        </div>
      </div>

      <div style={cardStyle}>
        <div style={{ display: "flex", justifyContent: "space-between", gap: 12, flexWrap: "wrap", marginBottom: 14 }}>
          <div>
            <div style={{ color: "#64748b", fontSize: 13, fontWeight: 700 }}>
              Lista de prioridade
            </div>

            <div style={{ color: "#0f172a", fontSize: 18, fontWeight: 900 }}>
              Leads que precisam de ação imediata
            </div>
          </div>

          <div style={{ color: "#64748b", fontSize: 12, fontWeight: 700 }}>
            Regra: quanto maior o score, maior a urgência.
          </div>
        </div>

        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 1050 }}>
            <thead>
              <tr style={{ color: "#64748b", textAlign: "left", fontSize: 12 }}>
                <th style={{ padding: "10px 8px" }}>Prioridade</th>
                <th style={{ padding: "10px 8px" }}>Lead</th>
                <th style={{ padding: "10px 8px" }}>Vendedor</th>
                <th style={{ padding: "10px 8px" }}>Status</th>
                <th style={{ padding: "10px 8px" }}>Parado há</th>
                <th style={{ padding: "10px 8px" }}>Mensagens</th>
                <th style={{ padding: "10px 8px" }}>Follow-up</th>
                <th style={{ padding: "10px 8px" }}>Motivo</th>
                <th style={{ padding: "10px 8px" }}>Ação</th>
              </tr>
            </thead>

            <tbody>
              {leads.length === 0 ? (
                <tr>
                  <td colSpan="9" style={{ padding: 16, color: "#64748b" }}>
                    Nenhum lead aberto ou pendente encontrado.
                  </td>
                </tr>
              ) : (
                leads.slice(0, 30).map(lead => (
                  <tr key={lead.id} style={{ borderTop: "1px solid #e5e7eb" }}>
                    <td style={{ padding: "12px 8px" }}>
                      <div style={{ color: scoreColor(lead.leadScore), fontWeight: 900 }}>
                        {lead.leadScore}
                      </div>

                      <div
                        style={{
                          display: "inline-block",
                          marginTop: 4,
                          borderRadius: 999,
                          padding: "4px 8px",
                          fontSize: 11,
                          fontWeight: 900,
                          color: scoreColor(lead.leadScore),
                          background: `${scoreColor(lead.leadScore)}18`
                        }}
                      >
                        {scoreLabel(lead.leadScore)}
                      </div>
                    </td>

                    <td style={{ padding: "12px 8px", fontWeight: 800, color: "#0f172a" }}>
                      #{lead.id} - {lead.contactName || "Contato"}
                      <div style={{ color: "#64748b", fontSize: 11, fontWeight: 600 }}>
                        Atualizado: {formatDateTime(lead.updatedAt)}
                      </div>
                    </td>

                    <td style={{ padding: "12px 8px" }}>
                      {lead.sellerName || "Sem vendedor"}
                    </td>

                    <td style={{ padding: "12px 8px", fontWeight: 900 }}>
                      {lead.status}
                    </td>

                    <td style={{ padding: "12px 8px", color: "#ef4444", fontWeight: 900 }}>
                      {minutes(lead.minutesStopped)}
                    </td>

                    <td style={{ padding: "12px 8px" }}>
                      <strong>{lead.totalMessages || 0}</strong>
                      <div style={{ color: "#64748b", fontSize: 11 }}>
                        Cliente: {lead.customerMessages || 0} | Vendedor: {lead.sellerMessages || 0}
                      </div>
                    </td>

                    <td style={{ padding: "12px 8px", fontWeight: 900, color: lead.hasFutureFollowUp ? "#16a34a" : "#dc2626" }}>
                      {lead.hasFutureFollowUp ? "Sim" : "Não"}
                    </td>

                    <td style={{ padding: "12px 8px", color: scoreColor(lead.leadScore), fontWeight: 800 }}>
                      {lead.mainReason || "Monitorar"}
                    </td>

                    <td style={{ padding: "12px 8px" }}>
                      <button
                        onClick={() => openTicket(lead.uuid)}
                        style={{
                          border: 0,
                          borderRadius: 10,
                          padding: "8px 12px",
                          background: "#b91c1c",
                          color: "#fff",
                          fontWeight: 800,
                          cursor: "pointer"
                        }}
                      >
                        Abrir lead
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div style={{ ...cardStyle, marginTop: 16 }}>
        <div style={{ color: "#64748b", fontSize: 13, fontWeight: 700 }}>
          Ranking de risco por vendedor
        </div>

        <div style={{ color: "#0f172a", fontSize: 18, fontWeight: 900, marginBottom: 14 }}>
          Quem acumula mais leads críticos
        </div>

        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 760 }}>
            <thead>
              <tr style={{ color: "#64748b", textAlign: "left", fontSize: 12 }}>
                <th style={{ padding: "10px 8px" }}>#</th>
                <th style={{ padding: "10px 8px" }}>Vendedor</th>
                <th style={{ padding: "10px 8px" }}>Leads</th>
                <th style={{ padding: "10px 8px" }}>Críticos</th>
                <th style={{ padding: "10px 8px" }}>Score médio</th>
              </tr>
            </thead>

            <tbody>
              {sellerRanking.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ padding: 16, color: "#64748b" }}>
                    Nenhum ranking encontrado.
                  </td>
                </tr>
              ) : (
                sellerRanking.map((seller, index) => (
                  <tr key={seller.userId || index} style={{ borderTop: "1px solid #e5e7eb" }}>
                    <td style={{ padding: "12px 8px", fontWeight: 900 }}>{index + 1}</td>
                    <td style={{ padding: "12px 8px", fontWeight: 800 }}>{seller.sellerName}</td>
                    <td style={{ padding: "12px 8px" }}>{seller.totalLeads || 0}</td>
                    <td style={{ padding: "12px 8px", color: "#dc2626", fontWeight: 900 }}>{seller.criticalLeads || 0}</td>
                    <td style={{ padding: "12px 8px", color: scoreColor(seller.averageScore), fontWeight: 900 }}>{seller.averageScore || 0}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LeadScoreDashboard;
